import { render, staticRenderFns } from "./regulatory-agency-staff-management.vue?vue&type=template&id=6b9fc97c&"
import script from "./regulatory-agency-staff-management.vue?vue&type=script&lang=js&"
export * from "./regulatory-agency-staff-management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports